import { BaseChartProps } from '../types/chartProps';
import { applyColors } from './colorsUtils';
import { applyXAxisOptions, applyYAxisOptions } from './axisUtils';
import { applyLegendOptions } from './legendUtils';
import { applyPlotSeriesOptions } from './plotOptionsUtils';
import { applyTooltipOptions } from './tooltipUtils';
import { redrawPlotLines } from './chartDefaults';
import { applyDescriptionOptions, applyTitleOptions } from './commonChartUtils';

export function applyRedrawForBaseChart(options: { skip: boolean }) {
  return function (this: Highcharts.Chart) {
    if (options.skip) {
      return;
    }
    options.skip = true;
    const plotLines = redrawPlotLines(this);
    this.yAxis[0].update({ plotLines });
  };
}

export function applyBaseChartOptions(options: Highcharts.Options, params: BaseChartProps) {
  const fns = [
    applyTitleOptions,
    applyDescriptionOptions,
    applyXAxisOptions,
    applyYAxisOptions,
    applyPlotSeriesOptions,
    applyLegendOptions,
    applyTooltipOptions,
    applyColors
  ];
  return fns.reduce((acc, fn) => fn(acc, params), options);
}
